import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { useExternalOAuthOpener, useShouldUseDirectOAuthUrl, } from '#pplx/frontend/apps/ask/connectors/hooks/useExternalOAuthOpener.js';
import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const useEnsureMigrationTargetPickerConnection = ({ reason, }) => {
    const queryClient = useQueryClient();
    const { $t } = useIntl();
    const { openToast } = useToastContext();
    const openExternalUrl = useExternalOAuthOpener();
    const shouldUseDirectOAuthUrl = useShouldUseDirectOAuthUrl();
    const { refetch: refetchUserSettingsWithPickerCredentials } = useUserSettingsQuery({
        reason,
        enabled: false,
        skipConnectorPickerCredentials: false,
    });
    return useCallback(async ({ currentConnector, targetSourceId }) => {
        const { ensureMigrationTargetPickerConnection } = await import('#pplx/frontend/apps/ask/connectors/hooks/useMigrationTargetReconnectGate.js');
        return ensureMigrationTargetPickerConnection({
            currentConnector,
            targetSourceId,
            reason,
            queryClient,
            refetchUserSettings: refetchUserSettingsWithPickerCredentials,
            openToast,
            $t,
            openExternalUrl,
            shouldUseDirectOAuthUrl,
        });
    }, [
        reason,
        queryClient,
        refetchUserSettingsWithPickerCredentials,
        openToast,
        $t,
        openExternalUrl,
        shouldUseDirectOAuthUrl,
    ]);
};
//# sourceMappingURL=useEnsureMigrationTargetPickerConnection.js.map